import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Constants from "../../../../Constants";

const CorefeedbackViewForm = ({
  isFeedbackUpdateInProgress,
  isCreationInProgress,
  handleCreationofDocument,
  isChat,
  onAutoTuneChanged = () => {},
  onAdminResolutionChanged = () => {},
  children,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const { values } = AppForms.useFormikContext();
  useEffect(() => {
    onAutoTuneChanged(values.autoTune);
  }, [values.autoTune]);
  useEffect(() => {
    onAdminResolutionChanged(values.adminResolution);
  }, [values.adminResolution]);
  return (
    <>
      <AppForms.AppFormField
        showTextInputLabel
        wrapperInputStyle={{
          paddingTop: 10,
          marginHorizontal: 5,
        }}
        textContainer={{
          minHeight: 120,
          paddingVertical: 10,
          marginHorizontal: 20,
        }}
        textInputLabelStyle={{
          marginLeft: 20,
        }}
        multiline={true}
        label={t("admin.humanFeedback.resolution")}
        placeholder={t("admin.humanFeedback.resolutionPlaceholder")}
        keyboardtype="default"
        textContextType="label"
        autoCorrect={false}
        name="adminResolution"
      />
      <AppForms.AppFormSwitch
        // disabled={true}
        wrapperStyle={[
          {
            // backgroundColor: currentTheme?.theme?.lightGrey,
            maxHeight: 30,
            // paddingHorizontal: 10,
            borderRadius: 10,
            paddingVertical: 18,
            marginHorizontal: 20,
            marginTop: -5,
            marginBottom: 5,
            width: "auto",
          },
        ]}
        labelTextStyle={{
          fontSize: currentTheme?.theme?.small_font_size,
          color: currentTheme?.theme?.darkGrey,
        }}
        showTextInputLabel={true}
        label={t("admin.humanFeedback.markAsResolved")}
        displayIsTicked={true}
        name="adminChecked"
        description={t("admin.humanFeedback.markAsResolvedDesc")}
        descriptionIcon={false}
        descriptionColor={currentTheme?.theme?.mediumGrey}
      />
      <AppForms.AppFormSwitch
        disabled={values?.adminResolution?.length < 10 || !isChat}
        wrapperStyle={[
          {
            // backgroundColor: currentTheme?.theme?.lightGrey,
            maxHeight: 30,
            // paddingHorizontal: 10,
            borderRadius: 10,
            paddingVertical: 18,
            marginHorizontal: 20,
            marginTop: 5,
            marginBottom: 5,
            width: "auto",
          },
        ]}
        labelTextStyle={{
          fontSize: currentTheme?.theme?.small_font_size,
          color: currentTheme?.theme?.darkGrey,
        }}
        showTextInputLabel={true}
        label={t("admin.humanFeedback.finetuneFromResolution")}
        displayIsTicked={true}
        name="autoTune"
        description={t("admin.humanFeedback.finetuneFromResolutionDesc")}
        descriptionIcon={false}
        descriptionColor={currentTheme?.theme?.mediumGrey}
      />
      <AppText
        style={{
          paddingLeft: 5,

          fontSize: currentTheme?.theme?.extra_small_font_size,
        }}
        wrapperStyle={{
          top: 0,
          justifyContent: "center",
          marginTop: 30,
          marginRight: 30,
          marginLeft: 20,
        }}
        iconSize={12}
        leftIcon={AppAssets?.icons?.question_icon}
      >
        {t("admin.humanFeedback.autotuneHint")}
      </AppText>

      <AppText
        leftIcon={AppAssets?.icons?.magic}
        iconSize={18}
        color={currentTheme?.theme?.primary}
        isClickable={!isCreationInProgress}
        style={{
          marginLeft: 10,
          textDecorationColor: currentTheme?.theme?.primary,
          fontWeight: "bold",
        }}
        wrapperStyle={{
          padding: 15,
          marginRight: 12,
          marginLeft: 5,
        }}
        onPress={() => handleCreationofDocument(values)}
      >
        {isChat
          ? t("admin.humanFeedback.createTrainingDocumentFromChat")
          : t("admin.humanFeedback.createTrainingDocumentFromOutput")}
      </AppText>

      {children}

      <AppForms.AppSubmitButton
        title={t("common.save")}
        isDisabled={isFeedbackUpdateInProgress}
        awesomeIconColor={currentTheme?.theme?.white}
        backgroundColor={currentTheme?.theme?.primary}
        btnContentStyle={{
          paddingLeft: 0,
          paddingRight: 0,
        }}
        style={[
          {
            height: Constants.appButtonHeight,
            width: "auto",
            shadowColor: currentTheme?.theme?.transparent,
            marginHorizontal: 10,
          },
        ]}
        // btnLabelStyle={{ fontSize: 16 }}
        wrapperStyle={[
          {
            width: "fit-content",
            minWidth: 150,
            marginTop: 20,
            alignSelf: "center",
            height: Constants.appButtonHeight,
          },
        ]}
      />
    </>
  );
};

export default CorefeedbackViewForm;
